import React, { useEffect, useRef } from "react";
import styles from "./dashboard.module.scss";
import Carousel from "react-elastic-carousel";
import Product from "../../components/product/Product";
import Title from "../../components/title/Title";

const CustDashboard = (props) => {

  const { data, selectedRegion } = props;
  const myCustCarousel = useRef(null);

  const showHideLeftCustArrow = () => {
    // document.querySelector("#customerContainer #scrollToEnd").style.display = "none";
    if (document.querySelector("#customerContainer .rec.rec-arrow-left")) {
      document.querySelector("#customerContainer #scrollToEnd").style.display = "none";
      if (document.querySelector("#customerContainer .rec.rec-arrow-left").disabled) {
        document.querySelector("#customerContainer #scrollToEnd").style.display = "block";
      }
      else {
        document.querySelector("#customerContainer #scrollToEnd").style.display = "none";
      }
    }
  }

  const showHideRightCustArrow = () => {
    //  document.querySelector("#customerContainer #scrollToStart").style.display = "none";
    if (document.querySelector("#customerContainer .rec.rec-arrow-right")) {
      //document.querySelector("#customerContainer #scrollToStart").style.display = "none";
      if (document.querySelector("#customerContainer .rec.rec-arrow-right").disabled) {
        document.querySelector("#customerContainer #scrollToStart").style.display = "block";
      }
      else {
        document.querySelector("#customerContainer #scrollToStart").style.display = "none";
      }
    }
  }

  const myCustCarouselChange = (current, pagenum) => {
    showHideLeftCustArrow();
    showHideRightCustArrow();
  }

  const onClickCustScrollToStart = () => {
    document.querySelector("#customerContainer #scrollToStart").style.display = "none";
    myCustCarousel?.current?.goTo(0);
  }


  const onClickCustScrollToEnd = () => {/*Left Cust Arrow- which takes to dead end */
    document.querySelector("#customerContainer #scrollToEnd").style.display = "none";
    myCustCarousel?.current?.goTo(data.customers.length);
  }

  useEffect(() => {
    document.querySelector("#customerContainer #scrollToEnd").style.display = "block";
    document.querySelector("#customerContainer #scrollToStart").style.display = "none";
    myCustCarousel?.current?.goTo(0);
  }, [selectedRegion]);

  useEffect(() => {
    document.querySelector("#customerContainer #scrollToEnd").style.display = "block";
    document.querySelector("#customerContainer #scrollToStart").style.display = "none";
    myCustCarousel?.current?.goTo(0);
  }, []);


  const customerBreakPoints = [
    { width: 1, itemsToShow: 1 },
    { width: 550, itemsToShow: 2, itemsToScroll: 2 },
    { width: 850, itemsToShow: 3, itemsToScroll: 2 },
    { width: 1120, itemsToShow: 4, itemsToScroll: 4 },
    { width: 1450, itemsToShow: 6, itemsToScroll: 5 },
    { width: 1750, itemsToShow: 7, itemsToScroll: 6 }
  ]

  const showCustomerDetail = (item) => {
    props.setCustomer(item)
    props.setSubRegion({})
    props.history.push("/dashboard/customerdetail");
  }

  return (
    <div className={styles.groupCustContainer}>
      <div id="customerContainer" className={styles.grpCustproductsContainer}>
        {<div className={styles.scrollEndParent}>
          <div id="scrollToEnd" className={`${styles.leftArrow} ${styles.buttonStyle} `} onClick={() => onClickCustScrollToEnd()}>{"❮"}</div>
        </div>}
        {
          <div className={`row no-gutters ${styles.customerLayoutBx} ${styles.customerList} ${styles.tilePaddingbottom}`}>
            <Title value="Customers" count={data.customers.length} />
            <Carousel ref={myCustCarousel}
              onChange={(currentItem, pageIndex) =>
                myCustCarouselChange(currentItem, pageIndex)}
              breakPoints={customerBreakPoints}>
              {data.customers.map((item, index) => {
                return (
                  <Product
                    key={index}
                    product={item}
                    {...props}
                    type="customer"
                    showDetail={showCustomerDetail}
                  />
                );
              })}
            </Carousel>
          </div>
        }


        {<div className={styles.scrollStartParent}>
          <div id="scrollToStart" className={`${styles.rightArrow} ${styles.buttonStyle} `} onClick={() => onClickCustScrollToStart()}>{"❯"}</div>
        </div>}
      </div>
    </div>

  )
}
export default CustDashboard;